module.exports = __webpack_public_path__ + "977afab7489fdabb0e4c718a1d761842.pdf";